const getRootDomain = (url: string | undefined): string | null => {
  if (!url) return null;
  try {
    const { hostname } = new URL(url);
    const parts = hostname.split('.');
    if (hostname.endsWith('myshopify.com')) return hostname;
    if (parts.length >= 3 && parts[0] === 'www')
      return parts.slice(1).join('.');
    return hostname;
  } catch (e) {
    return null;
  }
};

export default getRootDomain;
